/**
  * 配色 接口的出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const manghecolors = {
    // 列表
    manghehomecolorlist(params) {
        return axios.get(api + 'manghehomecolor/list', { params: params })
    },
    //添加
    manghehomecolorcreate(params) {
        return axios.post(api + 'manghehomecolor/create', qs.stringify(params))
    },
    //获取编辑信息
    manghehomecolordetail(params) {
        return axios.get(api + 'manghehomecolor/detail', { params: params })
    },
    //修改
    manghehomecoloredit(params) {
        return axios.post(api + 'manghehomecolor/edit', qs.stringify(params))
    },
    //删除
    manghehomecolorremove(params) {
        return axios.post(api + 'manghehomecolor/remove', qs.stringify(params))
    },
    //更改状态
    manghehomecolorstatus(params) {
        return axios.post(api + 'manghehomecolor/status', qs.stringify(params))
    }
}


// 导出接口
export default manghecolors
